module.exports = __webpack_public_path__ + "static/media/a4.ca35b041.ogg";